import axios from "../helper/axiosWithHeader";

export default class Analysis {
    async getSales(type) {
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/analysis/sales/${type}`);
        return result
    }
}